{
	"Subtype_Attraction": "Attraction",
	"Subtype_Blood": "Blood",
	"Subtype_Clue": "Clue",
	"Subtype_Contraption": "Contraption",
	"Subtype_Equipment": "Equipment",
	"Subtype_Food": "Food",
	"Subtype_Fortification": "Fortification",
	"Subtype_Gold": "Gold",
	"Subtype_Incubator": "Incubator",
	"Subtype_Map": "Map",
	"Subtype_Powerstone": "Powerstone",
	"Subtype_Treasure": "Treasure",
	"Subtype_Vehicle": "Vehicle"
}